<template>
  <div>
    <b-row>
      <b-col cols="12">
        <swaps-filter :get-report-data="getData" />
      </b-col>
      <b-col
        v-if="loading"
        cols="12"
      >
        <loading-card />
      </b-col>
      <template v-else>
        <b-col
          cols="12"
          md="4"
        >
          <default-card
            title="Toplam Satış"
            color="success"
            icon="CheckCircleIcon"
            :value="rates.grandTotal.sales"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <default-card
            title="Toplam Takas"
            color="info"
            icon="RepeatIcon"
            :value="rates.grandTotal.swaps"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <default-card
            title="Takas Oranı"
            color="warning"
            icon="PercentIcon"
            :value="rates.grandTotal.rates"
            prefix="%"
          />
        </b-col>
        <b-col
          v-for="rate in rates.data"
          :key="rate.id"
          cols="12"
          md="6"
        >
          <second-ratio-card
            :card-title="rate.title"
            title="Satış Adet"
            second-title="Takas Adet"
            :swap-value="rate.swaps"
            :value="rate.sales"
            :rate="[rate.rates]"
            rate-title="Takas Oranı"
          />
        </b-col>
      </template>
    </b-row>
  </div>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import SwapsFilter from '@/views/I2Sales/FilterCards/SwapsFilter.vue'
import SecondRatioCard from '@/layouts/components/ReportCards/SecondRatioCard.vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import DefaultCard from '@/layouts/components/ReportCards/DefaultCard.vue'

export default {
  name: 'I2SwapSales',
  components: {
    LoadingCard,
    SecondRatioCard,
    SwapsFilter,
    DefaultCard,
    BRow,
    BCol,
  },
  computed: {
    loading() {
      return this.$store.getters['i2SaleSwapsReports/loading']
    },
    rates() {
      return this.$store.getters['i2SaleSwapsReports/rates']
    },
    ratesParams() {
      return this.$store.getters['i2SaleSwapsReports/ratesParams']
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('i2SaleSwapsReports/getRates', this.ratesParams)
    },
  },
}
</script>
